import React, { useContext, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { AppContext, DispatchContext } from "../AppContext";
import Paper from '@material-ui/core/Paper';
import { makeStyles } from "@material-ui/styles";
import * as actions from '../actions/actions';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { Typography, IconButton } from '@material-ui/core';
import { config, formatPercent, blendColors, resolveNotificationMessage } from '../helpers/constants';
import IconLabel from './IconLabel';
import Service from "../services/service";
import CircularLoading from "./CircularLoading";
import ReactTooltip from "react-tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    padding: 8,
    lineHeight: '18px',
    height: "100%",
    position: "relative"
  },
  tooltip: {
    maxWidth: "480px !important",
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  paper: {
    display: "flex",
    flex: "1 1 0",
    minHeight: 8,
    padding: 10,
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.1)",
    zIndex: 2,
  },
  content: {
    display: 'flow-root',
    flexDirection: "row",
    flex: "1 1 0",
    minHeight: 0,
    overflowX: "hidden",
    overflowY: "auto",
    height: "100%",
    wordBreak: "break-word",
    whiteSpace: (state) => { return (state.ui.showLinebreaks) ? "pre-line" : ""; }
  },
  span: {
    position: "relative",
    cursor: "pointer",
    border: "1px solid white",
    zIndex: "10",
  },
  spanIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    opacity: 0.2,
    "&:hover": {
      opacity: 1
    }
  },
  accepted: {
    backgroundImage: "url(/gfx/accepted-stripe.png)", // created with http://www.patternify.com/
  },
  mainDiv: {
    margin: 0,
    padding: 0,
    height: "30px",
    position: "relative",
  },
  centerDiv: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
  },
  divider: {
    width: "75%",
    height: "2px",
    backgroundColor: theme.palette.secondary.main,
    opacity: 0.2,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  common_div: {
    overflow: "hidden",
    width: "100%",
  },
  contentLeft: {
    overflowY: "scroll",
    overflowX: "hidden",
    height: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  displayNone: {
    display: 'none',
  }
}));


export default function SourceData(props) {
  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const classes = useStyles(state);
  const { refData, scrollToContent, hoverToContent, hoverToOutContent, handleOpen } = props;
  const [ctrlPressed, setCtrlPressed] = useState(false);
  const [loading, setLoading] = useState(false);
  const s = state.strings;

  // Register key down handler for Ctrl key handling
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress, false);
    document.addEventListener("keyup", handleKeyUp, false);
    return () => {
      document.removeEventListener("keydown", handleKeyPress, false);
      document.removeEventListener("keyup", handleKeyUp, false);
    };
  }, []);

  // load source markup for single source view if active source has changed
  useEffect(() => {
    if ((state.activeReport) && (state.activeReport.Status == "Ok") && (state.ui.sourcesView == 'sources') && (state.activeSource.Id)) {
      setLoading(true);
      Service.getSourceMarkup(state.activeSource.Id, state.ui.permaLinkId).then(res => {
        setLoading(false);
        if (res.success && res.data) {
          dispatch(actions.setSourceMarkup(res.data));
        } else {
          dispatch(actions.openToast({ type: "error", message: "Comparsion Data not Found!", status: true }));
        }
      });
    }
  }, [state.activeSource, state.ui.reportDisplayMode, state.activeReport.Status]);

  useEffect(() => {
    if ((state.activeReport) && (state.activeReport.Status == "Ok") && (state.activeReport.TextOverlayExists)) {
      setLoading(true);
      Service.getTextOverlay(state.activeReportId, state.ui.statisticsType, state.ui.permaLinkId).then(res => {
        setLoading(false);
        if (res.success) {
          dispatch(actions.set_text_overlay(res.data));
        }
        else {
          dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
        }
      });
    }
}, [state.ui.statisticsType, state.activeReportId, state.ui.permaLinkId, state.activeReport.Status]);



const handleExpandTextButton = () => {
  ReactTooltip.hide();
  dispatch(actions.setUI({ showTextWithoutMarkup: true }));
}

const activateSource = (source, plagSource) => {
  scrollToContent(source.SId)
  const storeSource = state.activeSource;
  if (plagSource.Id != storeSource.Id) {
    dispatch(actions.setActiveSource(plagSource));
  }
  if (ctrlPressed) {
    handleOpen(true, plagSource.Id);
  }
}

// Hover In effect 
const activateHover = (source) => {
  hoverToContent('list' + source.SIdx);
  hoverToContent(source.SId);
}

// Hover Out effect 
const activateHoverOut = (source) => {
  hoverToOutContent('list' + source.SIdx);
  hoverToOutContent(source.SId);
}

// select all rows if Ctrl+A has been pressed
const handleKeyPress = (e) => {
  if (e.ctrlKey) {
    setCtrlPressed(true);
    return false;
  }

}

const handleKeyUp = (e) => {
  setCtrlPressed(false);
}

const getSourceTip = (source, plagSource) => {
  return (source.Sim ?
    `<b>${s.reportReview.sourceTipHeader.format(source.SIdx, plagSource.MW, formatPercent(plagSource.Percent), source.PIdx, plagSource.MP, formatPercent(source.Sim))}</b><br />${plagSource.Title}<br><i>${s.reportReview.sourceTooltipHint}</i>`
    :
    `<b>${s.reportReview.sourceTipHeaderNoSim.format(source.SIdx, plagSource.MW, formatPercent(plagSource.Percent), source.PIdx, plagSource.MP)}</b><br />${plagSource.Title}<br><i>${s.reportReview.sourceTooltipHint}</i>`
  );
}

const getStatsTip = (index) => {
  if (!state.textOverlay)
    return "";

  return (state.ui.statisticsMode == 'v') ?
    `${s.kiDetector[state.ui.textOverlay[state.ui.statisticsType].title]}: ${state.textOverlay[index][state.ui.statisticsMode].toPrecision(3)}`
    :
    `${s.kiDetector[state.ui.textOverlay[state.ui.statisticsType].title]}: ${state.textOverlay[index][state.ui.statisticsMode].toPrecision(3)}<br />${s.kiDetector.rawValue}: ${state.textOverlay[index]['v'].toPrecision(3)}`
}

const getStatsValues = () => state.ui.textOverlay[state.ui.statisticsType] ? state.ui.textOverlay[state.ui.statisticsType].values : state.ui.textOverlay['default'].values;
const getStatsColors = () => state.ui.textOverlay[state.ui.statisticsType] ? state.ui.textOverlay[state.ui.statisticsType].colors : state.ui.textOverlay['default'].colors;

//return (<div className={classes.root}>Source List Panel</div>);
return (
  <div className={classes.root}>

    <Paper elevation={3} className={classes.paper}>
      {state.activeReport && state.activeReport.Status == "Ok" && state.ui.sourcesView == 'sources' && state.ui.reportDisplayMode == 'source' &&
        <div className={classes.common_div}>
          <Grid id="report-text-scroll" container className={classes.contentLeft}>
            <CircularLoading visible={loading} />

            {!loading &&
              (state.sourceMarkup && state.sourceMarkup.Text2 ?
                <span>
                  {state.sourceMarkup.Text2.Markup.map((source, index) => {
                    if (source.PIdx == null) return source.T;
                    var color = state.ui.colors[source.PIdx % 10];
                    return (
                      <span key={index} style={{ backgroundColor: color }}>{source.T}</span>
                    );
                  })}
                </span> :
                <IconLabel centered label={s.reportReview.selectSource} />)
            }
          </Grid>
        </div>
      }

      {state.activeReport && state.activeReport.Status == "Ok" && state.ui.sourcesView == 'statistics' &&
        <>
          <Grid id="report-text-scroll" container className={classes.content}>
            <CircularLoading visible={loading} />
            {!loading && (state.overlayStatistics && state.overlayStatistics.phrases && state.overlayStatistics.phrases.length && state.reportMarkup.length ?
                <span>
                  {(() => {
                    // Render statistics view using reportMarkup text content.
                    // Phrase indexes match stats array indexes 1:1 (new API).
                    // Excluded regions are exactly 1 phrase (ex:true on stat entry).
                    // Server phrase positions {s, l} are UTF-8 byte offsets, so we
                    // build a byteOffset→charIndex map to handle multi-byte chars (German umlauts etc.)
                    const phrases = state.overlayStatistics.phrases;
                    const statsType = state.ui.statisticsType || 'kil';
                    const statsMode = state.ui.statisticsMode || 'md';
                    const statsArray = state.overlayStatistics[statsType];
                    const fullText = state.reportMarkup.map(t => t.T || '').join('');

                    // Build byte→char index map
                    const byteToChar = [];
                    for (let ci = 0; ci < fullText.length; ) {
                      const cp = fullText.codePointAt(ci);
                      const bl = cp < 0x80 ? 1 : cp < 0x800 ? 2 : cp < 0x10000 ? 3 : 4;
                      for (let b = 0; b < bl; b++) byteToChar.push(ci);
                      ci += cp >= 0x10000 ? 2 : 1;
                    }
                    byteToChar.push(fullText.length);
                    const b2c = (byteOff) => byteOff < byteToChar.length ? byteToChar[byteOff] : fullText.length;

                    const typeTitle = state.ui.textOverlay[statsType] ? state.ui.textOverlay[statsType].title : '';
                    const makeTip = (statsEntry) => {
                      if (!statsEntry) return '';
                      const val = statsEntry[statsMode];
                      if (val == null) return '';
                      const label = s.kiDetector[typeTitle] || typeTitle;
                      return statsMode === 'v'
                        ? `${label}: ${val.toPrecision(3)}`
                        : `${label}: ${val.toPrecision(3)}<br />${s.kiDetector.rawValue}: ${statsEntry['v'].toPrecision(3)}`;
                    };

                    // Build segments: gaps between phrases are plain text;
                    // each phrase maps 1:1 to the stats array index.
                    // Excluded regions are exactly 1 phrase (ex:true in the stat entry).
                    const segments = [];
                    let cursor = 0; // char index
                    for (let i = 0; i < phrases.length; i++) {
                      const p = phrases[i];
                      const cStart = b2c(p.s);
                      const cEnd   = b2c(p.s + p.l);
                      if (cursor < cStart) {
                        segments.push({ text: fullText.slice(cursor, cStart), phraseIdx: -1 });
                      }
                      const statEntry = statsArray && statsArray[i];
                      const isEx = statEntry && statEntry.ex;
                      segments.push({ text: fullText.slice(cStart, cEnd), phraseIdx: i, isEx });
                      cursor = cEnd;
                    }
                    if (cursor < fullText.length) {
                      segments.push({ text: fullText.slice(cursor), phraseIdx: -1 });
                    }

                    const truncateExcluded = !state.ui.showTextWithoutMarkup;

                    return segments.map((seg, si) => {
                      if (seg.phraseIdx === -1) {
                        return <React.Fragment key={si}>{seg.text}</React.Fragment>;
                      }
                      if (seg.isEx) {
                        if (truncateExcluded) {
                          const words = seg.text.split(' ');
                          if (words.length > config.truncateChars) {
                            const half = Math.floor(config.truncateChars / 2);
                            const firstText = words.slice(0, half).join(' ');
                            const lastText = words.slice(words.length - half).join(' ');
                            return (
                              <React.Fragment key={si}>
                                <span style={{ color: '#bbbbbb' }}>{firstText}</span>
                                {" "}
                                <div className={classes.mainDiv}>
                                  <div className={classes.divider}></div>
                                  <IconButton data-for="globalTT" data-tip={s.reportReview.showAllText} size="small" onClick={handleExpandTextButton} className={classes.centerDiv}>
                                    <MoreHorizIcon color="secondary" />
                                  </IconButton>
                                </div>
                                <span style={{ color: '#bbbbbb' }}>{lastText}</span>
                              </React.Fragment>
                            );
                          }
                        }
                        return <span key={si} style={{ color: '#bbbbbb' }}>{seg.text}</span>;
                      }
                      const statsEntry = statsArray && statsArray[seg.phraseIdx];
                      const statValue = statsEntry && statsEntry[statsMode];
                      if (statValue == null) {
                        return <React.Fragment key={si}>{seg.text}</React.Fragment>;
                      }
                      const color = blendColors(statValue, getStatsColors(), getStatsValues());
                      return (
                        <span data-for="sourceTT" data-tip={makeTip(statsEntry)} key={si} style={{ backgroundColor: color }}>{seg.text}</span>
                      );
                    });
                  })()}
                </span> :
                <IconLabel centered label={"No Text Overlay"} />)
            }
          </Grid>
        </>
      }

      {state.activeReport && state.activeReport.Status == "Ok" && state.ui.sourcesView == 'sources' && state.ui.reportDisplayMode == 'merged' &&
        <>
          <Grid id="report-text-scroll" container className={classes.content}>
            <CircularLoading visible={!state.loadingSourceDetail } />
            {state.reportMarkup.length ?
              (() => {
                // Step 1: group consecutive non-finding items so truncation applies
                // across the merged run rather than per individual markup item.
                const displayGroups = [];
                for (let i = 0; i < state.reportMarkup.length; i++) {
                  const source = state.reportMarkup[i];
                  const plagSource = state.sources.find(s => s && s.Id == source.SId);
                  if (!source.PIdx || !plagSource) {
                    // Non-finding item — append to current text group or start one
                    const last = displayGroups[displayGroups.length - 1];
                    if (last && last.type === 'text') {
                      last.items.push(source);
                    } else {
                      displayGroups.push({ type: 'text', items: [source] });
                    }
                  } else {
                    displayGroups.push({ type: 'plag', source, plagSource });
                  }
                }

                // Step 2: helper — flatten items into word-level tokens with color info
                const toWords = (items) => {
                  const words = [];
                  for (const item of items) {
                    const ws = item.T ? item.T.toString().split(" ") : [];
                    const isExcluded = item.ERIdx != null;
                    for (const w of ws) words.push({ w, isExcluded });
                  }
                  return words;
                };

                // Step 3: helper — render an array of word tokens as React nodes,
                // grouping consecutive same-color runs into spans.
                const renderRuns = (words, keyPrefix) => {
                  const runs = [];
                  for (const wt of words) {
                    const last = runs[runs.length - 1];
                    if (last && last.isExcluded === wt.isExcluded) {
                      last.words.push(wt.w);
                    } else {
                      runs.push({ words: [wt.w], isExcluded: wt.isExcluded });
                    }
                  }
                  return runs.map((run, i) =>
                    run.isExcluded
                      ? <span key={keyPrefix + '_r' + i} style={{ color: '#bbbbbb' }}>{run.words.join(" ")}</span>
                      : <React.Fragment key={keyPrefix + '_r' + i}>{run.words.join(" ")}</React.Fragment>
                  );
                };

                // Step 4: render each display group
                return displayGroups.map((group, groupIndex) => {
                  if (group.type === 'plag') {
                    const { source, plagSource } = group;
                    return (
                      <span key={groupIndex}
                        data-for="sourceTT" data-tip={getSourceTip(source, plagSource)}
                        ref={refData} id={source.SId + '_source' + '_phase_' + source.PIdx}
                        onClick={() => activateSource(source, plagSource)}
                        onMouseOver={() => activateHover(source)}
                        onMouseLeave={() => activateHoverOut(source)}
                        style={{ backgroundColor: state.ui.colors[source.SIdx % 10] }}
                        className={`${source.SId} ${(plagSource.Accepted == 1) ? classes.accepted : ''} ${classes.span} ${(state.ui.filterPIdx == 0 || state.ui.filterPIdx == source.SIdx) ? classes[source.SIdx] : ''}`}>
                        {source.T}
                      </span>
                    );
                  }

                  // Text group
                  const words = toWords(group.items);
                  if (words.length > config.truncateChars && !state.ui.showTextWithoutMarkup) {
                    const half = Math.floor(config.truncateChars / 2);
                    const firstWords = words.slice(0, half);
                    const lastWords = words.slice(words.length - half);
                    return (
                      <React.Fragment key={groupIndex}>
                        {renderRuns(firstWords, groupIndex + '_f')}
                        {"... "}
                        <div className={classes.mainDiv}>
                          <div className={classes.divider}></div>
                          <IconButton data-for="globalTT" data-tip={s.reportReview.showAllText} size="small" onClick={handleExpandTextButton} className={classes.centerDiv}>
                            <MoreHorizIcon color="secondary" />
                          </IconButton>
                        </div>
                        {"..."}
                        {renderRuns(lastWords, groupIndex + '_l')}
                      </React.Fragment>
                    );
                  }
                  return (
                    <React.Fragment key={groupIndex}>
                      {renderRuns(words, groupIndex + '_a')}
                    </React.Fragment>
                  );
                });
              })() :
              (state.loadingSourceDetail && <IconLabel centered type="check" label={s.noRelevantSources} />)
            }
          </Grid>

        </>
      }
    </Paper>
  </div>
)
}
